// import now from "./Now";
import { now } from "@zyzgroup/core-common";
import Sequence from "./Sequence";

import Easing from "./Easing";
export { Easing, type EasingFunction, reverseEasing } from "./Easing";
export * from "./BezierEasing";

import Interpolation from "./Interpolation";
export { Interpolation, type InterpolationFunction } from "./Interpolation";

import Tween from "./Tween";
export * from "./Tween";

import Group from "./Group";
export * from "./Group";
import { mainGroup } from "./mainGroup";

const nextId = Sequence.nextId;

// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
const getAll = mainGroup.getAll.bind(mainGroup);
const removeAll = mainGroup.removeAll.bind(mainGroup);
const add = mainGroup.add.bind(mainGroup);
const remove = mainGroup.remove.bind(mainGroup);
const update = mainGroup.update.bind(mainGroup);

export const TWEEN = {
  now,
  Sequence,
  Easing,
  Interpolation,
  Group,
  Tween,
  nextId,
  getAll,
  removeAll,
  add,
  remove,
  update
};
export default TWEEN;
